import React, { useState, useEffect } from 'react';

import { Redirect } from 'react-router-dom';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

/**
 * @typedef {Object} CheckLocaleProps
 * @property {string[]} locales - An array of locales that are allowed to access the page. Can either be an array of locale codes (e.g.: ["us", "jp", etc.]) or country names (e.g.: ["United States", "United_States" "Japan", etc.])
 * @property {boolean} useCountryCode - Check and compare the lang.code to an array of locales. Will default to false, but used as a fallback if no type is explicitly defined.
 * @property {boolean} useCountryNames - Check and compare the lang.country name instead of the locale code
 */

/**
 * Compares an array of locale codes against the current locale and redirects user to the main page if they are not part of the allowed locales
 * @param {CheckLocaleProps} props
 * @returns {JSX.Element}
 */
const CheckLocale = ({ locales, useCountryCode = false, useCountryNames = false }) => {
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const localesArray = Array.isArray(locales) ? locales : [locales];

  useEffect(() => {
    const compareLocale = async () => {
      const { code, country } = await StorageHandler.load(storageKeys.lang);

      const useDefaultFallback = !useCountryCode && !useCountryNames;

      if (useCountryNames && !localesArray.map((country) => country.toLowerCase()).includes(country.toLowerCase())) {
        setShouldRedirect(true);
        return;
      }

      if (
        (useCountryCode || useDefaultFallback) &&
        !localesArray.map((code) => code.toLowerCase()).includes(code.toLowerCase())
      ) {
        setShouldRedirect(true);
        return;
      }
    };
    compareLocale();
  }, []);

  return <React.Fragment>{shouldRedirect && <Redirect to="/main" />}</React.Fragment>;
};

export default CheckLocale;
